import {
  Divider,
  GlobalStyles,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import Messages from "../Messages";
import { useMessageThreads } from "src/context/MessageThreadsProvider";
import SelectLanguage from "src/components/SelectLanguage";
import { useTranslation } from "react-i18next";
import HomeFilledIcon from "src/assets/icons/HomeFilledIcon";

interface ThreadProps {
  page: string;
}

const MobileMessagingThread = ({ page }: ThreadProps) => {
  const navigate = useNavigate();
  const { currentThread } = useMessageThreads();
  const { i18n, t } = useTranslation();

  const threadName = useMemo(() => currentThread?.name, [currentThread]);
  const languange = useMemo(() => i18n.language, [i18n.language]);
  const category = useMemo(() => {
    if (currentThread == null) return "";

    return currentThread.product_category.name.replace(" ", "").toLowerCase();
  }, [currentThread]);

  return (
    <>
      <GlobalStyles
        styles={{
          "#root": {
            padding: "1rem",
            boxSizing: "border-box",
            height: "100dvh",
            overflow: "hidden",
          },
        }}
      />
      <Stack direction={"column"} height="100%" gap={1}>
        <Stack
          width={"100%"}
          direction="row"
          gap={1}
          alignItems="center"
          data-testid="mobile-message-thread"
          justifyContent={"space-between"}
        >
          <IconButton
            size="small"
            onClick={() => navigate(-1)}
            sx={{ color: "#00B6B9" }}
          >
            <HomeFilledIcon fontSize="medium" />
          </IconButton>
          <Typography fontWeight={600} variant="body1">
            {t(`${page}.${category}.threadHeader`, {
              product:
                languange === "en" ? threadName : threadName?.toLowerCase(),
            })}
          </Typography>

          <SelectLanguage />
        </Stack>

        <Divider
          sx={{
            backgroundColor: "#E4E7EE",
          }}
        />
        <Stack flex={1} maxHeight="86vh">
          <Messages />
        </Stack>
      </Stack>
    </>
  );
};

export default MobileMessagingThread;
